export default {
  title: `トレンドマイクロアカウント`,
  titleIDP: `トレンドマイクロ ID プロテクション`,
  titleTMC: `トレンドマイクロ 詐欺バスター`,
  description: `トレンドマイクロアカウントにログインすると個人向けソフトウェアのライセンスを管理できます。`,

  brandedTitle: `トレンドマイクロ株式会社`,
  brandedHeadline: `アカウント`,
  helpCenter: `サポート`,
  contactSupport: `お問い合わせ`,
  legalPoliciesPrivacy: `プライバシーポリシー`,
  contactUs: `お問い合わせ`,
  copyright: `Copyright © {year} Trend Micro Incorporated. All rights reserved.`,
  copyrightStatement: `Copyright © {year} Trend Micro Incorporated.`,
  allRightReserved: `All rights reserved.`,
  auth: {
    continueWithEmail: `Continue with Email`,
  },
  error_msg: {
    common: `問題が発生しました。`,
    tryLater: `しばらくしてからやりなおしてください。`,
    errorCode: 'Error code: {error_code}',
  },
  pageUnavaliableTitle: '現在、このページは使用できません',
  pageUnavaliableContent: '問題が発生しました。トレンドマイクロの担当者が確認を進めています。',
  pageUnavaliableContent1: 'リクエストを処理できません。',
  sorryForInconvenience: 'ご迷惑をおかけして申し訳ありません。',
  contactSupport1:
    '同じ状況が繰り返し続く場合は、{contact_support}の上、次のエラーコードをお知らせください。',
  contactSupportText: 'サポート担当者にお問い合わせ',
  vbUpgrade: {
    title: 'ワンランク上のセキュリティへ',
    subtitle: 'アップグレード＋自動更新申し込み',
    feature_1: '最大6台のデバイス保護',
    feature_2: '個人情報の保護',
    feature_3: 'パスワード管理',
    feature_4: 'フリーWi-Fi接続の保護',
    feature_5: '365日のデジタルライフサポート',
  },
  oot: {
    title: 'サービス (30日無料期間付) の利用開始',
    subtitle: 'サービス利用開始のお手続き',
    feature_1: '最大6台のデバイス保護',
    feature_2: '個人情報の保護',
    feature_3: 'パスワード管理',
    feature_4: 'フリーWi-Fi接続の保護',
  },
  countryRegions: {
    '092': '英領バージン諸島',
    100: 'ブルガリア',
    104: 'ビルマ (ミャンマー)',
    108: 'ブルンジ',
    112: 'ベラルーシ',
    116: 'カンボジア',
    12: 'アルジェリア',
    120: 'カメルーン',
    124: 'カナダ',
    132: 'ベルデ岬',
    136: 'ケイマン諸島',
    140: '中央アフリカ共和国',
    144: 'スリランカ',
    148: 'チャド共和国',
    152: 'チリ',
    156: '中国',
    158: '台湾',
    16: 'アメリカ領サモア',
    162: 'クリスマス島',
    166: 'ココス (キーリング) 諸島',
    170: 'コロンビア',
    174: 'コモロ',
    175: 'マヨット島',
    178: 'コンゴ共和国',
    180: 'コンゴ民主共和国',
    184: 'クック諸島',
    188: 'コスタリカ',
    191: 'クロアチア',
    196: 'キプロス',
    20: 'アンドラ公国',
    203: 'チェコ共和国',
    204: 'ベニン',
    208: 'デンマーク',
    212: 'ドミニカ国',
    214: 'ドミニカ共和国',
    218: 'エクアドル',
    222: 'エルサルバドル',
    226: '赤道ギニア',
    231: 'エチオピア',
    232: 'エリトリア',
    233: 'エストニア',
    234: 'フェロー諸島',
    238: 'フォークランド諸島',
    24: 'アンゴラ',
    242: 'フィジー',
    246: 'フィンランド',
    248: 'オーランド諸島',
    250: 'フランス',
    254: '仏領ギアナ',
    258: '仏領ポリネシア',
    262: 'ジブチ',
    266: 'ガボン',
    268: 'グルジア',
    270: 'ガンビア',
    276: 'ドイツ',
    28: 'アンティグア・バーブーダ',
    288: 'ガーナ',
    292: 'ジブラルタル',
    296: 'キリバス',
    300: 'ギリシア',
    304: 'グリーンランド',
    308: 'グレナダ',
    31: 'アゼルバイジャン',
    316: 'グアム島',
    32: 'アルゼンチン',
    320: 'グアテマラ',
    324: 'ギニア',
    328: 'ガイアナ',
    332: 'ハイチ',
    336: 'バチカン市国',
    340: 'ホンジュラス',
    344: '香港',
    348: 'ハンガリー',
    352: 'アイスランド',
    356: 'インド',
    36: 'オーストラリア',
    360: 'インドネシア',
    368: 'イラク',
    372: 'アイルランド',
    376: 'イスラエル',
    380: 'イタリア',
    384: 'コートジボワール',
    388: 'ジャマイカ',
    392: '日本',
    398: 'カザフスタン',
    4: 'アフガニスタン',
    40: 'オーストリア',
    400: 'ヨルダン',
    404: 'ケニア',
    410: '大韓民国',
    414: 'クウェート',
    417: 'キルギスタン',
    418: 'ラオス',
    422: 'レバノン',
    426: 'レソト',
    428: 'ラトビア',
    430: 'リベリア',
    438: 'リヒテンシュタイン',
    44: 'バハマ諸島',
    440: 'リトアニア',
    442: 'ルクセンブルグ',
    446: 'マカオ',
    450: 'マダガスカル',
    454: 'マラウィ',
    458: 'マレーシア',
    462: 'モルジブ',
    466: 'マリ共和国',
    470: 'マルタ島',
    478: 'モーリタニア',
    48: 'バーレーン',
    480: 'モーリシャス島',
    484: 'メキシコ',
    492: 'モナコ',
    496: 'モンゴル国',
    498: 'モルドバ',
    50: 'バングラデシュ',
    500: 'モントセラト島',
    504: 'モロッコ',
    508: 'モザンビーク共和国',
    51: 'アルメニア',
    512: 'オマーン国',
    516: 'ナミビア',
    52: 'バルバドス',
    520: 'ナウル共和国',
    524: 'ネパール',
    528: 'オランダ',
    530: 'オランダ領アンティル',
    533: 'アルバ島',
    540: 'ニューカレドニア',
    548: 'バヌアツ',
    554: 'ニュージーランド',
    558: 'ニカラグア',
    56: 'ベルギー',
    562: 'ニジェール',
    566: 'ナイジェリア',
    570: 'ニウエ島',
    574: 'ノーフォーク島',
    578: 'ノルウェー',
    580: '北マリアナ諸島',
    583: 'ミクロネシア連邦',
    584: 'マーシャル諸島',
    585: 'パラオ',
    586: 'パキスタン',
    591: 'パナマ',
    598: 'パプアニューギニア',
    60: 'バーミューダ諸島',
    600: 'パラグアイ',
    604: 'ペルー',
    608: 'フィリピン',
    612: 'ピトケアン諸島',
    616: 'ポーランド',
    620: 'ポルトガル',
    624: 'ギニアビサウ',
    626: '東ティモール',
    630: 'プエルトリコ',
    634: 'カタール',
    638: 'レユニオン',
    64: 'ブータン',
    642: 'ルーマニア',
    643: 'ロシア',
    646: 'ルワンダ',
    654: 'セントヘレナ島',
    659: 'セントクリストファー・ネイビス',
    660: 'アングィラ',
    662: 'セントルシア',
    666: 'サンピエール島・ミクロン島',
    670: 'セントビンセントおよびグレナディーン諸島',
    674: 'サンマリノ',
    678: 'サントメ・プリンシペ',
    68: 'ボリビア',
    682: 'サウジアラビア',
    686: 'セネガル',
    690: 'セイシェル',
    694: 'シエラレオネ',
    70: 'ボスニア・ヘルツェゴビナ',
    702: 'シンガポール',
    703: 'スロバキア',
    704: 'ベトナム',
    705: 'スロベニア',
    706: 'ソマリア',
    710: '南アフリカ',
    716: 'ジンバブエ',
    72: 'ボツワナ',
    724: 'スペイン',
    732: '西サハラ',
    740: 'スリナム',
    744: 'スバールバル諸島',
    748: 'スワジランド',
    752: 'スウェーデン',
    756: 'スイス',
    76: 'ブラジル',
    762: 'タジキスタン',
    764: 'タイ',
    768: 'トーゴ',
    772: 'トケラウ諸島',
    776: 'トンガ',
    780: 'トリニダード・トバゴ',
    784: 'アラブ首長国連邦',
    788: 'チュニジア',
    792: 'トルコ',
    795: 'トルクメニスタン',
    796: 'タークス・カイコス諸島',
    798: 'ツバル',
    8: 'アルバニア',
    800: 'ウガンダ',
    804: 'ウクライナ',
    807: 'マケドニア',
    818: 'エジプト',
    826: '英国',
    831: 'ガーンジー島',
    832: 'ジャージー島',
    833: 'マン島',
    834: 'タンザニア',
    84: 'ベリーズ',
    840: '米国',
    850: '米領バージン諸島',
    854: 'ブルキナファソ',
    858: 'ウルグアイ',
    860: 'ウズベキスタン',
    862: 'ベネズエラ',
    876: 'ワリス・フテュナ諸島',
    882: 'サモア諸島',
    887: 'イエメン',
    891: 'セルビア',
    894: 'ザンビア',
    90: 'ソロモン諸島',
    96: 'ブルネイ',
    9891: 'モンテネグロ',
  },
  nameDisplay: `{lastName}`,
};
